import React, { useRef } from "react";
import { error, information, success, warning, close } from "podro-design-system/lib/svg";
import "./toastMessage.scss";

const ToastMessage = props => {
    const { onDismiss, type, children } = props;
    const toastE = useRef(null);
    const icon = () => {
        switch (type) {
            case "warning":
                return warning;
            case "error":
                return error;
            case "information":
                return information;
            case "success":
                return success;
            default: 
                return information;
        }
    };
    
    const title = () => {
        switch (type) {
            case "warning":
                return "هشدار";
            case "error":
                return "خطا";
            case "information":
                return "اطلاعات";
            case "success":
                return "موفق";
            default:
                return "اطلاعات";
        }
    };

    return (
        <div 
        ref={toastE}
         className="toast-message show">
            <div className={`badge badge-${type}`}>
                <span className="badge-icon">{icon()}</span>
            </div>
            <div className="toast-content">
                <p className="toast-content-type">{title()}</p>
                <p className="toast-content-text">{children}</p>
            </div>
            <div className="toast-action" onClick={() => {
                    // hidden();
                    setTimeout(() => {
                        onDismiss();
                    }, 500);
                }}>
                {close}
            </div>
        </div>
    );
};

ToastMessage.defaultProps = {
    type: "success",
};

export default ToastMessage;
